export type AddressType = {
    registration_type?: string
    address_type: string
    street_number: string
    street_extension: string | null
    street_name: string
    street_name_further: string
    city: {
        zipcode: string
        name: string
    },
    country: string
    id: string
}

export enum AddressEnumType {
    postale = 'postale',
    fiscale = 'fiscale'
}

export type CodeNifType = {
    country: string 
    code: string
}

export type IbanType = {
    iban: string,
    bic: string,
    bank_name: string
}

export type AccountType = {
    index: number,
    title: string,
    type: string,
    is_transfer: boolean | null,
    id: string | null,
    demand_id?: string,
    disabled: boolean,
    fees: {
        brokerage: string,
        custody: string
    },
    accessAuthorization?: boolean,
    is_peaj: boolean
}

export type CountryType = {
    name: string,
    alpha2: string,
    alpha3: string,
    numeric: number,
    is_ue: boolean,
    phone_extension: string,
    rank: number
}

export type SearchAddressType = {
    city: string | null, 
    citycode: string | null,  
    housenumber: string | null,  
    label: string | null, 
    postcode: string | null, 
    score: string | null, 
    street: string | null
}

export enum DocumentLabelType {
    image = 'image',
    pdf = 'pdf'
}

export enum DocumentType {
    frontBack = 'front-back-id',
    front = 'front-id',
    back = 'back-id',
    address = 'address',
    id = 'id'
}

export enum DocumentTypeDetail {
    idcard = 'idcard',
    back = 'back-id',
    passport = 'passport',
    others = 'others'
}

export enum StatusType {
    refused = 'refused',
    pending = 'pending',
    accepted = 'accepted',
    error = 'error'
}

export type DocumentStatusDataType = {
    accounts: AccountType[];
    documents: [];
    hasFolder: boolean;
    signable: boolean;
    signed_at: string;
    step: string;
    transfert: [];
}

export type DocumentStatusObjectType = {
    type: string;
    filename: string;
    status: string;
    message: string;
    type_detail: string;
    file_ext: string;
    iban?: string;
}

export enum UserRoleType {
    Client = 'client',
    Member = 'member',
    Premium = 'premium member',
    Demo = 'demo',
}

export type EdealDocument = {
    id: string;
    filename: string;
    status: string;
    size?: number | null;
    type: {
        name: string;
        label: string;
    };
    type_detail: {
        name: string;
        label: string;
    };
}

export type Beneficiary = {
    data: {
        id?: string,
        is_legal_representative: boolean,
        is_beneficial_owner: boolean,
        shareholding: string,
        person: {
            civility: string,
            firstname: string,
            lastname: string,
            birthname: string,
            residence_country: string,
            birthdate: number,
            birth_country: string,
            address: {
                street_number: string,
                street_extension: string,
                street_name: string,
                street_name_further: string,
                city: {
                    zipcode: string,
                    name: string
                },
                country: string
            },
            phone: string,
            email: string
        }
    },
    documents: EdealDocument[]
}

export type CompanyDocumentsType = {
    id: string;
    filename: string;
    status: string;
    size: number | null;
    frontKey: string;
    type: string;
    type_detail: string;
    title: string;
}

export enum PartnerCode {
    CGPAS = 'CGPAS'
}
